import CookieConsent from './src/cookie-consent.mjs';
export default CookieConsent;